// Import model
import { LocationFieldOptions } from '../models/LocationFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LocationFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class LocationFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a LocationFieldOptions instance
   */
  static deserialize(json: string): LocationFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LocationFieldOptions instance
   */
  static fromObject(obj: any): LocationFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LocationFieldOptions');
    }


    const instance: LocationFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      e2A56Eb9: obj['_e2a56eb9'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LocationFieldOptions instances
   */
  static deserializeArray(json: string): LocationFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LocationFieldOptions instance to a JSON string
   */
  static serialize(instance: LocationFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LocationFieldOptions instance to a plain object
   */
  static toObject(instance: LocationFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_e2a56eb9': instance.e2A56Eb9,
    };
  }

  /**
   * Serializes an array of LocationFieldOptions instances to a JSON string
   */
  static serializeArray(instances: LocationFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
